// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
/** @ngInject */
export function Controller(
    $scope,
    $state,
    $uibModal,
    Alert,
    RecoverySettingsService,
) {
    this.$onInit = () => {
    $scope.formData = {};
    $scope.turnedOff = false;
    $scope.hasRecovery = true;
    $scope.questionAnswerPattern = /^(\S.{4,198}\S)$/;
    $scope.choosenNumber = 0;
    var recoverySetting = {};
    var data = this.recoverySettingsData;
    this.activeNumbers = this.phoneNumbers.filter((number) => number.status === 'ACTIVE');
    var userPhoneNumber = this.activeNumbers[0];
    if (userPhoneNumber) {
        $scope.choosenNumber = userPhoneNumber.id;
    }
    $scope.delay = {};
    $scope.ask = {};
    $scope.delay.immediateRadio = data.sendRecoverySmsImmediately;
    $scope.turnedOff = data.recoveryTurnedOff;
    $scope.recoveryPhoneNumber = data.userPhoneNumber;
    if ($scope.recoveryPhoneNumber) {
        $scope.hasRecovery = true;
    } else {
        $scope.hasRecovery = false;
    }
    if (data.recoverySecurityQuestion) {
        $scope.ask.questionRadio = true;
        $scope.formData.question = data.recoverySecurityQuestion.recoverySecurityQuestion;
        $scope.formData.answer = data.recoverySecurityQuestion.recoverySecurityQuestionAnswer;
    } else {
        $scope.ask.questionRadio = false;
    }

    $scope.updateChoosenNumber = function(id) {
        $scope.choosenNumber = id;
    };

    $scope.setRecoveryNumber = function() {
        if ($scope.choosenNumber == 0) {
            $state.go('^.add');
        } else {
            RecoverySettingsService.setRecoveryNumber.get({
                phoneNumberId : $scope.choosenNumber
            }).$promise.then(function(data) {
                $state.go('^.list', {}, {reload: '^'});
                Alert('success', 'recovery.action_text.recovery_number_set');
            });
        }
    };

    $scope.turnOff = function() {
        $uibModal
            .open({component: 'confirmTurnOffRecovery'}).result
            .then(() => {
        RecoverySettingsService.turnOffRecovery.save(function(data) {
            $state.go('^.list', {}, {reload: '^'});
            Alert('success', 'recovery.action_text.turn_off_success');
        }, function() {
            Alert('danger', 'recovery.action_text.turn_off_failed');
        });
        });
    };
    $scope.removeRecovery = function() {
        $uibModal
            .open({component: 'confirmRemoveRecovery'}).result
            .then(() => {
        RecoverySettingsService.removeRecovery.save(function(data) {
            $state.go('^.list', {}, {reload: '^'});
            Alert('success', 'recovery.action_text.remove_success');
        }, function() {
            Alert('danger', 'recovery.action_text.turn_off_failed');
        });
        });
    };
    $scope.updateRecovery = function() {
        $uibModal
            .open({component: 'confirmUpdateRecovery'}).result
            .then(() => {
        recoverySetting.sendRecoverySmsImmediately = $scope.delay.immediateRadio;
        if ($scope.ask.questionRadio) {
            var recoverySecurityQuestion = {
                recoverySecurityQuestion : $scope.formData.question,
                recoverySecurityQuestionAnswer : $scope.formData.answer
            }
            recoverySetting.recoverySecurityQuestion = recoverySecurityQuestion;
        } else {
            recoverySetting.recoverySecurityQuestion = null;
        }
        RecoverySettingsService.updateSettings.save(recoverySetting, function(data) {
            Alert('success', 'recovery.action_text.update_success');
            $state.go('^.list', {}, {reload: '^'});

        }, function() {
            Alert('danger', 'recovery.action_text.update_failed');
        });
        });
    };
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/recovery-settings/recovery-settings.controller.js